if (!customElements.get("product-card-media")) {
  customElements.define(
    "product-card-media",
    class ProductCardMedia extends HTMLElement {
      constructor() {
        super();
        this.slider = false;
      }

      connectedCallback() {
        this.wrapper = this.querySelector(".m-product-card__media-list");
        this.slides = this.querySelectorAll(".m-product-card__media-slide");

        if (!this.wrapper || this.slides.length < 2) return;

        this.init();
        document.addEventListener("matchMobile", this.init.bind(this));
        document.addEventListener("unmatchMobile", this.init.bind(this));
      }

      init() {
        if (MinimogTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      }

      initSlider() {
        if (this.slider) return;

        const media = this.closest(".m-product-card__media");
        const pagination = media ? media.querySelector(".m-product-card__media-dots") : null;

        this.slider = new MinimogLibs.Swiper(this, {
          wrapperClass: "m-product-card__media-list",
          slideClass: "m-product-card__media-slide",
          threshold: 2,
          spaceBetween: 0,
          slidesPerView: 1,
          watchOverflow: true,
          pagination: pagination
            ? {
                el: pagination,
                type: "bullets",
                clickable: true,
              }
            : false,
        });
      }

      destroySlider() {
        if (!this.slider) return;

        this.slider.destroy(true, true);
        this.slider = false;
      }
    }
  );
}
